import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60000,
            cacheTime: 30 * 60 * 1000,
            refetchOnWindowFocus: false,
        },
    },
});